import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PertinenceExistenceFormComponent } from './pertinence-existence-form/pertinence-existence-form.component';
import { InformationsRenouvellementFormComponent } from './informations-renouvellement-form/informations-renouvellement-form.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatButtonModule } from '@angular/material/button';
import { MatStepperModule } from '@angular/material/stepper';
import { MatIconModule } from '@angular/material/icon';
import { ArianeNavComponent } from 'src/app/layout/ariane-nav/ariane-nav.component';
import { MatDividerModule } from '@angular/material/divider';
import { SituationAdministrativeFormComponent } from './situation-administrative-form/situation-administrative-form.component';
import { AbstractControl, FormBuilder, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { StepperSelectionEvent } from '@angular/cdk/stepper';
import { DestinatairesFormComponent } from './destinataires-form/destinataires-form.component';
import { DemandeRenouvellementService } from 'src/app/core/services/demande-renouvellement.service';
import { MatDialog } from '@angular/material/dialog';
import { ValidationModalComponent } from 'src/app/shared/validation-modal/validation-modal.component';
import { finalize, Subject, takeUntil } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { FormStateService } from 'src/app/core/services/form-state.service';
import { AgentsService } from 'src/app/core/services/agents.service';
import { noWhitespaceValidator } from 'src/app/shared/utils/no-whitespace-validator';
import { ServiceFonctionnelPoste as ServiceFonctionnel } from '@models/domains/posts';
import { CdisationData } from '@models/api/requests';

@Component({
    selector: 'app-renouvellement',
    imports: [
        CommonModule,
        MatDividerModule,
        ArianeNavComponent,
        MatIconModule,
        MatStepperModule,
        MatButtonModule,
        MatSelectModule,
        MatFormFieldModule,
        SituationAdministrativeFormComponent,
        InformationsRenouvellementFormComponent,
        PertinenceExistenceFormComponent,
        DestinatairesFormComponent
    ],
    templateUrl: './renouvellement.component.html',
    styleUrls: ['./renouvellement.component.scss']
})
export class RenouvellementComponent implements OnInit {
  arianeLabel: string = 'Formulaire saisies demandes de renouvellement';
  arianeIcon: string = 'Contract_edit';
  arianeList = [
    {
      label: 'Formulaire saisies demandes de renouvellement',
      url: '/pama/renouvellement'
    }
  ];
  formTitles = [
    "Situation administrative de l'agent",
    'Informations sur le renouvellement',
    "Pertinence de l'existence de l'emploi",
    'Destinataires de la demande'
  ];
  formGroup: FormGroup;
  parentForm: FormGroup;
  currentStepIndex: number = 0;
  currentTitle = this.formTitles[this.currentStepIndex];
  nextTitle = this.formTitles[this.currentStepIndex + 1];
  isSubmitting = false;

  stepOneForm!: FormGroup;
  stepTwoForm!: FormGroup;
  stepThreeForm!: FormGroup;
  stepFourForm!: FormGroup;
  attachedfiles: File[] = [];
  private readonly destroy$ = new Subject<void>();

  cdisationData: CdisationData = {
    dateFinContrat: '',
    nbJoursAvantCdisation: 0,
    nbJoursAbsences: 0,
    nbJoursAbsencesSNF: 0,
    absenceMO: 0,
    absenceATMP: 0,
    absenceMDML: 0,
    absenceMAPA: 0,
    totalJoursAbsences: 0,
    flagCdisation: false,
    absenceDateDebut: '',
    absenceDateFin: '',
    snfDateDebut: '',
    snfDateFin: ''
  };

  agentServiceFonctionnel: ServiceFonctionnel;
  selectedDirection: any = null;

  agentId: string;
  constructor(
    private readonly fb: FormBuilder,
    private readonly formStateService: FormStateService,
    public dialog: MatDialog,
    private readonly demandeRenouvellementService: DemandeRenouvellementService,
    private readonly router: Router,
    private readonly activeRoute: ActivatedRoute,
    private readonly agentService: AgentsService
  ) { }
  ngOnInit() {
    this.initForm();
    // this.handleMotifChange();

    this.activeRoute.queryParams.subscribe((params) => {
      if (params['agentId']) {
        // Update arianeList to include consultation path
        this.arianeList = [
          {
            label: 'Consultation fin de contrats',
            url: '/pama/consultation-fin-contrats'
          },
          {
            label: 'Formulaire saisies demandes de renouvellement',
            url: '/pama/renouvellement'
          }
        ];
      }
      if (params['id']) {
        this.agentId = params['id'];
        this.loadAgentById(this.agentId);
      } else {
        this.initForm();
      }
    });
    this.parentForm.valueChanges.subscribe(() => {
      const isDirty = this.parentForm.dirty && !this.parentForm.valid;
      this.formStateService.setFormState(isDirty);
    });

    const serviceControl = this.step1.get('serviceFonctionnel');
    if (serviceControl) {
      this.agentServiceFonctionnel = serviceControl.value ?? null;
      serviceControl.valueChanges.pipe(takeUntil(this.destroy$)).subscribe((service) => {
        this.agentServiceFonctionnel = service;
      });
    }

    const directionControl = this.step1.get('direction');
    if (directionControl) {
      this.selectedDirection = directionControl.value ?? null;
      directionControl.valueChanges.pipe(takeUntil(this.destroy$)).subscribe((direction) => {
        this.selectedDirection = direction;
      });
    }
  }
  initForm() {
    this.parentForm = this.fb.group({
      //Form Situation administrative de l'agent
      step1: this.fb.group(
        {
          agent: ['', Validators.required],
          typeRenouvellement: ['', Validators.required],
          categoriePoste: [{ value: '', disabled: true }],
          identifiantAgent: [{ value: '', disabled: true }, Validators.required],
          grade: [{ value: '', disabled: true }, Validators.required],
          dateEntree: ['', Validators.required],
          posteOccupe: ['', Validators.required],
          tauxEmploi: ['', Validators.required],
          fonction: [{ value: '', disabled: true }, Validators.required],
          pole: ['', Validators.required],
          direction: ['', Validators.required],
          serviceFonctionnel: ['', Validators.required],
          typeContrat: ['', Validators.required],
          agentRemplace: [true, Validators.required],
          dateDebutContrat: ['', Validators.required],
          dateFinContrat: ['', Validators.required]
        },
        { validators: this.dateRangeValidator }
      ),
      //Form Informations sur le renouvellement
      step2: this.fb.group(
        {
          motif: ['', Validators.required],
          cdisable: [{ value: '', disabled: true }, Validators.required],
          confirmRefus: [false]
        },
        { validators: this.atLeastOneChecked }
      ),
      //Form Pertinence de l'existence de l'emploi
      step3: this.fb.group({
        pertinenceMission: ['', [Validators.required, this.maxLengthValidator(350), noWhitespaceValidator]],
        renouvellementJustifie: ['', [Validators.required, this.maxLengthValidator(720), noWhitespaceValidator]],
        files: [[], this.validateFiles]
      }),
      //Form Destinataires de la demande
      step4: this.fb.group({
        destinataireResponsable: ['', Validators.required],
        destinataireValidationDirecteur: ['', Validators.required],
        destinataireChargeGpeec: ['', Validators.required],
        destinataireDrh: ['', Validators.required],
        destinataireDg: ['', Validators.required],
        destinataireDgs: ['', Validators.required],
        destinataireArchivageRh: ['', Validators.required]
      })
    });
  }

  // handleMotifChange(): void {
  //   const motifControl = this.parentForm.get('step2.motif');
  //   const fileControl = this.parentForm.get('step3.files');
  //   const step3NextButton = document.getElementById('next-button-step3');

  //   motifControl?.valueChanges.subscribe((value) => {
  //     if (value === 'refusContratConditions') {
  //       fileControl?.setErrors({ required: true });
  //       fileControl?.setValidators([Validators.required, this.validateFiles]);
  //       step3NextButton?.setAttribute('disabled', 'true');
  //     } else {
  //       fileControl?.setErrors(null);

  //       fileControl?.setValidators(this.validateFiles);
  //       step3NextButton?.removeAttribute('disabled');
  //     }
  //     fileControl?.updateValueAndValidity();
  //   });
  // }

  loadAgentById(agentId: string) {
    if (!agentId) {
      this.initForm();
      return;
    }
    this.agentService.getAgentById(agentId).subscribe((agent) => {
      if (agent) {
        const selectedPole = agent.direction?.pole?.id;
        this.parentForm.patchValue({
          step1: {
            agent: agent,
            typeRenouvellement: agent.typeRenouvellement,
            categoriePoste: agent.categoriePoste,
            identifiantAgent: agent.identifiant,
            grade: agent.grade,
            dateEntree: agent.dateEntree,
            posteOccupe: agent.posteOccupe,
            tauxEmploi: agent.tauxEmploi,
            fonction: agent.fonction || '',
            pole: selectedPole,
            direction: agent.direction,
            typeContrat: agent.typeContrat,

            serviceFonctionnel: agent.serviceFonctionnel,
            agentRemplace: agent.agentRemplace ? 'true' : 'false',
            dateDebutContrat: agent.dateDebutContrat,
            dateFinContrat: agent.dateFinContrat
          }
        });
      }
    });
  }
  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  get step1() {
    return this.parentForm.get('step1') as FormGroup;
  }
  get step2() {
    return this.parentForm.get('step2') as FormGroup;
  }
  get step3() {
    return this.parentForm.get('step3') as FormGroup;
  }
  get step4() {
    return this.parentForm.get('step4') as FormGroup;
  }
  maxLengthValidator(maxLength: number): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const value = control.value;
      if (value && value.length > maxLength) {
        return { maxLengthExceeded: { value: control.value } };
      }
      return null;
    };
  }

  validateFiles(control: any) {
    const files = control.value;
    if (!files || files.length === 0) {
      return null;
    }
    const invalidFiles = files.filter((file: File) => file.type !== 'application/pdf');
    return invalidFiles.length === 0 ? null : { invalidFileType: true };
  }
  dateRangeValidator(formGroup: AbstractControl): { [key: string]: boolean } | null {
    const dateDebut = formGroup.get('dateDebutContrat')?.value;
    const dateFin = formGroup.get('dateFinContrat')?.value;
    if ((dateDebut && !dateFin) || (!dateDebut && dateFin)) {
      return { datesInvalide: true };
    }
    if (!dateDebut && !dateFin) {
      return { datesManquantes: true };
    }
    return null;
  }
  atLeastOneChecked(control: AbstractControl): ValidationErrors | null {
    const form = control as FormGroup;
    const values = Object.values(form.value);
    return values.some((value) => value) ? null : { atLeastOneChecked: true };
  }

  onStepChange(event: StepperSelectionEvent): void {
    this.currentStepIndex = event.selectedIndex;
    this.currentTitle = this.formTitles[this.currentStepIndex];
    this.nextTitle = this.formTitles[this.currentStepIndex + 1];
  }
  //Forms submision
  onChildformSubmit(step: number, formData: any) {
    switch (step) {
      case 1:
        this.stepOneForm = formData;

        break;
      case 2:
        this.stepTwoForm = formData;

        break;
      case 3:
        this.stepThreeForm = formData;

        break;
      case 4:
        this.stepFourForm = formData;

        break;
    }
  }

  mapFormDataToRequest(formData: any): any {
    const currentDate = new Date().toISOString().split('T')[0] + 'T00:00:00';

    const convertToNumber = (value: any) => {
      if (typeof value === 'string' && value.includes('%')) {
        return parseInt(value.replace('%', ''), 10);
      }
      return value;
    };

    return {
      id: formData?.id,
      agent: formData?.step1?.agent?.id ? { id: formData.step1.agent.id } : null,
      typeRenouvellement: formData?.step1?.typeRenouvellement?.id ? { id: formData.step1.typeRenouvellement.id } : null,
      tauxEmploi: convertToNumber(formData?.step1?.tauxEmploi),
      dateEntree: formData?.step1?.dateEntree ? new Date(formData.step1.dateEntree).toISOString().split('T')[0] : null,
      posteOccupe: { id: formData?.step1?.posteOccupe },
      typeContrat: { id: formData?.step1?.typeContrat },
      pole: { id: formData?.step1?.pole },
      direction: formData?.step1?.direction?.id ? { id: formData.step1.direction.id } : null,
      serviceFonctionnel: formData?.step1?.serviceFonctionnel?.id ? { id: formData.step1.serviceFonctionnel.id } : null,
      agentRemplace: formData?.step1?.agentRemplace ? 'true' : 'false',
      dateDebutContrat: formData?.step1?.dateDebutContrat ? new Date(formData.step1.dateDebutContrat).toISOString().split('T')[0] : null,
      dateFinContrat: formData?.step1?.dateFinContrat ? new Date(formData.step1.dateFinContrat).toISOString().split('T')[0] : null,
      contratMemePoste: formData?.step2?.motif === 'contratMemePoste' ? 'true' : 'false',
      contratConditionsDiffs: formData?.step2?.motif === 'contratConditionsDiffs' ? 'true' : 'false',
      refusContratDemande: formData?.step2?.motif === 'refusContratDemande' ? 'true' : 'false',
      refusContratConditions: formData?.step2?.motif === 'refusContratConditions' ? 'true' : 'false',
      pertinenceMission: formData?.step3?.pertinenceMission,
      renouvellementJustifie: formData?.step3?.renouvellementJustifie,
      statut: formData?.step4?.statut || 'A_VALIDER',
      destinataireValidation: formData.step4?.destinataireValidationDirecteur
        ? { id: formData.step4.destinataireValidationDirecteur.id }
        : null,
      destinataireCharge: formData.step4?.destinataireChargeGpeec ? { id: formData.step4.destinataireChargeGpeec.id } : null,
      destinataireDG: formData.step4?.destinataireDg ? { id: formData.step4.destinataireDg.id } : null,
      destinataireDRH: formData.step4?.destinataireDrh ? { id: formData.step4.destinataireDrh.id } : null,
      destinataireResponsable: formData.step4?.destinataireResponsable ? { id: formData.step4.destinataireResponsable.id } : null,
      destinataireDgs: formData.step4?.destinataireDgs ? { id: formData.step4.destinataireDgs.id } : null,
      destinataireArchivage: formData.step4?.destinataireArchivageRh ? { id: formData.step4.destinataireArchivageRh.id } : null
    };
  }

  onSubmitForm() {
    if (this.isSubmitting || !this.parentForm.valid) {
      return;
    }

    this.isSubmitting = true;
    const requestData = this.mapFormDataToRequest(this.parentForm.getRawValue());
    this.demandeRenouvellementService
      .createDemandesRenouvellement(requestData, this.attachedfiles)
      .pipe(
        takeUntil(this.destroy$),
        finalize(() => {
          this.isSubmitting = false;
        })
      )
      .subscribe({
        next: (result: any) => {
          this.dialog.closeAll();
          const dialogRef = this.dialog.open(ValidationModalComponent, {
            width: '600px',
            data: {
              title: 'Confirmation',
              content: 'La demande de renouvellement a été créée avec succès.'
            },
            disableClose: true
          });
          dialogRef.afterClosed().subscribe((result) => {
            if (result) {
              this.router.navigate(['/pama/consultation']);
            }
          });
        },
        error: (error: any) => {
          console.error('Erreur lors de la soumission', error);
          this.isSubmitting = false;
        }
      });
  }

  handleFileSelected(files: File[]) {
    this.attachedfiles = files;
  }

  isFormComplete(): boolean {
    return this.parentForm.dirty && !this.parentForm.valid;
  }

  updateCdisationData(agent: any) {
    if (agent) {
      this.cdisationData = {
        dateFinContrat: agent?.cdisationDate ?? '',
        nbJoursAvantCdisation: agent?.cdisationJoursRestants ?? 0,
        nbJoursAbsences: agent?.absenceTotal ?? 0,
        nbJoursAbsencesSNF: agent?.snfNb ?? 0,
        absenceMO: agent?.absenceMoNb ?? 0,
        absenceATMP: agent?.absenceAtmpNb ?? 0,
        absenceMDML: agent?.absenceMdmlNb ?? 0,
        absenceMAPA: agent?.absenceMapaNb ?? 0,
        totalJoursAbsences: agent?.absenceTotal ?? 0,
        flagCdisation: agent?.flagCdisation ?? false,
        absenceDateDebut: agent?.absenceDateDebut ?? '',
        absenceDateFin: agent?.absenceDateFin ?? '',
        snfDateDebut: agent?.snfDateDebut ?? '',
        snfDateFin: agent?.snfDateFin ?? ''
      };

      this.agentServiceFonctionnel = agent?.serviceFonctionnel;

      // Update the cdisable control in step2 form
      this.step2.patchValue({
        cdisable: agent.flagCdisation ? 'OUI' : 'NON'
      });
      this.step2.get('cdisable')?.disable();
    }
  }
}
